<app-tooltip-template label="reports.view" *ngIf="params.view">
  {{ 'select.' + params.view | translate }}
</app-tooltip-template>
